import { createReducer, on } from '@ngrx/store';
import * as SalesChannelsActions from './sales-channels.actions';
import { salesChannel } from 'src/app/pages/orders/interfaces/salesChannel.interface';

export interface SalesChannelsState {
  response: salesChannel[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: salesChannel[] };
}

export const initialState: SalesChannelsState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const salesChannelsReducer = createReducer(
  initialState,
  on(SalesChannelsActions.loadSalesChannels, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SalesChannelsActions.loadSalesChannelsSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(SalesChannelsActions.loadSalesChannelsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(SalesChannelsActions.loadSalesChannelsSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
